import { render, staticRenderFns } from "./ParosProgramados.vue?vue&type=template&id=b6a5a520&scoped=true&"
import script from "./ParosProgramados.vue?vue&type=script&lang=js&"
export * from "./ParosProgramados.vue?vue&type=script&lang=js&"
import style0 from "./ParosProgramados.vue?vue&type=style&index=0&id=b6a5a520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a5a520",
  null
  
)

export default component.exports